import { createContext, useContext } from 'react';
import type { StorefrontProduct } from '../../api/client';
export type BundleChoice = { product: StorefrontProduct; variantId: string; quantity: number };
export const BundleContext = createContext<((id: string, choice: BundleChoice | null) => void) | null>(null);
export const useBundleRegistration = () => useContext(BundleContext);
export const BundleHotspotsContext = createContext<{
  items: { id: string; title: string; x: number; y: number }[];
  active: string | null;
  select: (id: string) => void;
} | null>(null);
